export const TsChartProperties: any = {
  yAxis: [
    { // Observations chart left.
      opposite: false,
      labels: {
        align: 'right',
        x: -3,
        format: '{value} m/s',
        style: {
          color: '#666',
          fontSize: '11px',
        },
      },
      title: {
        text: 'Rate (m/s)',
      },
      height: '80%',
      lineColor: '#ccd6eb',
      lineWidth: 2,
      style: {
        color: '#666',
        fontSize: '11px',
      },
      resize: {
        enabled: true,
      },
    },
    { // Checks chart.
      opposite: true,
      showEmpty: false,
      labels: {
        enabled: false,
        align: 'right',
        x: -3,
        formatter() {
          return this.value + 'm/s';
        },
        style: {
          color: '#666',
          fontSize: '11px',
        },
      },
      title: {
        text: 'Checks',
      },
      top: '85%',
      height: '15%',
      offset: 0,
      lineWidth: 2,
      lineColor: '#ccd6eb',
      resize: {
        enabled: true,
      },
    },
    { // Observations chart right.
      opposite: true,
      showEmpty: false,
      labels: {
        align: 'right',
        x: -3,
        format: '{value} ',
        style: {
          color: '#666',
          fontSize: '11px',
        },
      },
      title: {
        text: 'Degrees',
      },
      height: '80%',
      lineWidth: 2,
      lineColor: '#ccd6eb',
      resize: {
        enabled: true,
      },
      offset: 0,
      floating: true,
    },
  ],
};
